// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fVf9","colMin":"styles_colMin__2qUYz"};